{
  "pending": "függőben levő"
}
